import React from 'react';
import { Switch } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

/* spring-needle-add-route-import - Spring base will add routes here */

const Routes = ({ match }) => (
  <div>
    <Switch>
      {/* prettier-ignore */}
      {/* spring-needle-add-route-path - Spring base will add routes here */}
    </Switch>
  </div>
);

export default Routes;
